//vuex
import store from '@v/Modules/Testimonials/Core/Site/store';


if (document.querySelector('div#testimonial-module-form')) {
    window.testimonals_module_form_vue_instance = new Vue({
        store,
        el: 'div#testimonial-module-form'
    });
}

window.logApplicationError = logApplicationError;